import { MutableRefObject } from "react";

import { DepositWithdrawCollaterals } from "../../constants/addresses";
import { ISignature } from "../../interfaces/Signing";

export enum ConnectWalletPageEnum {
  ONBOARD = 0,
  CONNECT_WALLET = 1,
  SWITCH_NETWORK = 2,
  ENABLE_TRADING_SIGN = 3,
  DEPOSIT = 4,
}

// We need this to allow the height to transition seamlessly
export type ConnectWalletPageHeightType = {
  [key in ConnectWalletPageEnum]: string;
};

export interface IConnectWalletModalProps {
  show?: boolean;
  onHide?: () => void;
}

export interface RunDepositOrApproveParams {
  depositActionInFlightRef: MutableRefObject<boolean>;
  setLoading: (value: boolean) => void;
  setPageError: (value: string) => void;
  setDepositError: (value: string) => void;
  depositReady: boolean;
  useUnifiedVaultFlow: boolean;
  isNativeDepositAsset: boolean;
  setUnifiedVaultApprovalChecked: (value: boolean) => void;
  decimals: number;
  isUnifiedVaultApproved: any;
  approveUnifiedVaultUSDC: any;
  setShowReadyToDepositMessage: (value: boolean) => void;
  l1DepositHelper: any;
  getAssetPermitSignature: any;
  getTimestamp: () => number;
  setApprovedAmountAndSignature: (value: {
    approvedAmount: string | undefined;
    signature: ISignature | undefined;
    deadline: number;
  }) => void;
  approvalSpender: any;
  approveAsset: any;
  setAssetAllowance: (value: string) => void;
  chainId: number | undefined;
  t: (key: string, options?: any) => string;
  assetToDeposit: DepositWithdrawCollaterals;
  depositToUnifiedVault: any;
  depositETHOptimismOrArbitrum: any;
  depositETH: any;
  l1Contract: any;
  l2Address: any;
  depositERC20OptimismOrArbitrum: any;
  yieldVaultToggle: boolean;
  approvedAmountAndSignature: {
    approvedAmount: string | undefined;
    signature: ISignature | undefined;
    deadline: number;
  };
  depositERC20WithPermit: any;
  depositERC20: any;
  setPendingDepositTxURL: (value: string | undefined) => void;
  mutate: any;
  onHideClicked: () => void;
  addToast: (toast: any, duration?: number) => void;
  playSound: (sound: any, loop?: boolean) => void;
}
